import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ee2f79e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createBlock(_component_q_radio, _mergeProps({
    class: [{ active: _ctx.brief.dobjId === _ctx.model }, "iuf-radio"],
    val: _ctx.brief.dobjId
  }, _ctx.RADIO_PROPS, {
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
    onClick: _ctx.selectBrief,
    onKeyup: _withKeys(_ctx.goNextStep, ["enter"])
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_avatar, {
          color: _ctx.getColorName(_ctx.brief.style, _ctx.brief.isArchived),
          class: "text-uppercase",
          "text-color": "white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.brief.name.charAt(0)), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        _createElementVNode("span", null, _toDisplayString(_ctx.brief.name), 1),
        _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.brief.name), 1)
          ]),
          _: 1
        }, 16),
        (_ctx.brief.isArchived)
          ? (_openBlock(), _createBlock(_component_iap_chip, {
              key: 0,
              class: "q-mt-none archive-chip",
              "non-interactive": "",
              rounded: "",
              size: "md",
              label: _ctx.t('ARCHIVED'),
              icon: _ctx.ICONS_NAME.ARCHIVE_BOX_SOLID
            }, null, 8, ["label", "icon"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_ctx.brief.group)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_iap_chip, {
                "tooltip-label": _ctx.brief.group.label,
                label: _ctx.brief.group.label
              }, null, 8, ["tooltip-label", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.brief.group)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " • "))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(_ctx.t('NUMBER_OF_LEADS', { count: _ctx.leadCount, lead: _ctx.t('LEAD.LOW.SING'), leads: _ctx.t('LEAD.LOW.PLUR') }, _ctx.leadCount)), 1)
      ])
    ]),
    _: 1
  }, 16, ["class", "val", "modelValue", "onClick", "onKeyup"]))
}